module.exports = __webpack_public_path__ + "static/media/whiteGo.c8640a2d.svg";